import { useEffect, useState } from "react";
import { format, parse, isValid } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";

const toDisplay = (iso) => (iso ? format(parse(iso, "yyyy-MM-dd", new Date()), "dd/MM/yyyy") : "");

const mask = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 8);
  return [d.slice(0, 2), d.slice(2, 4), d.slice(4, 8)].filter(Boolean).join("/");
};

export const DateInputFr = ({ value, onChange, testid }) => {
  const [text, setText] = useState(toDisplay(value));
  const [open, setOpen] = useState(false);
  useEffect(() => setText(toDisplay(value)), [value]);

  const commit = (t) => {
    if (!t) return onChange("");
    const d = parse(t, "dd/MM/yyyy", new Date());
    if (t.length === 10 && isValid(d)) onChange(format(d, "yyyy-MM-dd"));
    else setText(toDisplay(value));
  };

  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;

  return (
    <div className="relative">
      <Input
        value={text}
        placeholder="jj/mm/aaaa"
        inputMode="numeric"
        onChange={(e) => {
          const t = mask(e.target.value);
          setText(t);
          if (t.length === 10 || t === "") commit(t);
        }}
        onBlur={() => commit(text)}
        className="pr-10"
        data-testid={testid}
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md text-muted-foreground hover:text-genis hover:bg-secondary transition-colors" aria-label="Ouvrir le calendrier" data-testid={`${testid}-calendar-btn`}>
            <CalendarDays className="h-4 w-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            mode="single"
            locale={fr}
            weekStartsOn={1}
            selected={selected}
            defaultMonth={selected}
            onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
            initialFocus
            data-testid={`${testid}-calendar`}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
